import {BaseFilter} from "./base.filter";

export class UserFilter extends BaseFilter {
  accountId: string;
}
